import React from "react";
import { ImageOff } from "lucide-react";
import Reveal from "../Reveal";
import { buildWhatsAppLink, INSTAGRAM_URL } from "../../lib/api";
import { WhatsAppIcon, InstagramIcon } from "../BrandIcons";

const GallerySection = ({ tiles = [] }) => (
  <section id="collection" className="bg-white scroll-mt-24">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32">
      <Reveal className="text-center max-w-3xl mx-auto">
        <div className="overline">Our Collection</div>
        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-light mt-3 leading-[1.05] text-[#0F1245]">
          The Latest <span className="italic text-[#4A3FCF]">Edit.</span>
        </h2>
        <p className="mt-5 text-[15px] md:text-[16px] text-[#5A5F7A] leading-relaxed">
          Explore the newest additions to our collection.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {tiles.slice(0, 6).map((t, i) => (
          <Reveal key={i} delay={(i % 3) * 100} amount={0.08}>
            <a
              href={buildWhatsAppLink(
                `Hi Style India Delhi — please share rates and MOQ for "${t.name || t.category}".`
              )}
              target="_blank"
              rel="noreferrer"
              data-testid={`gallery-tile-${i}`}
              className="group block relative aspect-[3/4] overflow-hidden bg-[#0F1245] cursor-pointer"
            >
              {t.image_url ? (
                <img
                  src={t.image_url}
                  alt={t.name || t.category}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1100ms] ease-out group-hover:scale-110"
                />
              ) : (
                <div className="absolute inset-0 flex flex-col items-center justify-center image-placeholder">
                  <ImageOff size={26} strokeWidth={1.2} className="text-white/60" />
                  <p className="mt-3 text-[10px] tracking-[0.22em] uppercase text-white/50">900 × 1200 · 3:4</p>
                </div>
              )}

              {/* Hover dark gradient (revealed on hover) */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F1245]/95 via-[#0F1245]/55 to-[#0F1245]/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              {/* Subtle bottom shadow always visible (so titles are slightly hinted) */}
              <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#0F1245]/40 to-transparent group-hover:opacity-0 transition-opacity duration-500" />

              {/* Title block — slides up + fades in on hover */}
              <div className="absolute inset-x-0 bottom-0 p-6 md:p-7 translate-y-6 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 ease-out">
                {t.category && <div className="overline" style={{ color: "#B7E4F4" }}>{t.category}</div>}
                <h3 className="font-serif-display text-2xl md:text-[28px] text-white leading-tight mt-2">{t.name || t.category}</h3>
                <span className="mt-3 inline-flex items-center gap-2 text-[10px] tracking-[0.22em] uppercase font-semibold text-white">
                  <WhatsAppIcon size={12} /> Ask on WhatsApp
                </span>
              </div>

              {/* Top-right pill — visible on hover */}
              <span className="absolute top-4 right-4 bg-white text-[#0F1245] text-[10px] tracking-[0.22em] uppercase font-semibold px-3 py-1.5 opacity-0 group-hover:opacity-100 transition-all duration-500 transform group-hover:-translate-y-0">
                Enquire
              </span>
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-16 text-center">
        <p className="font-serif-display italic text-2xl md:text-3xl text-[#0F1245] max-w-3xl mx-auto leading-snug">
          Interested in our complete collection?
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="catalogue-whatsapp-btn"
            className="btn-primary"
          >
            <InstagramIcon size={14} /> Explore our Latest Collection
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default GallerySection;
